import { combineReducers } from 'redux';

import detachGoogleError from './detachGoogleError';
import detachTwitterError from './detachTwitterError';
import loadSocialNetworksError from './loadSocialNetworksError';

export default combineReducers({
  detachGoogleError,
  detachTwitterError,
  loadSocialNetworksError,
});
